import "./document-login.scss";

export function DocumentLogin() {
  return (
    <div className="document-login-wrapper">
      <zero-md src={process.env.PUBLIC_URL + "/READMELOGIN.md"}></zero-md>;
    </div>
  );
}
